export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://agp.ayssa.com.co/',
  apiGatewayBackOffice: 'https://agp.ayssa.com.co/',
  apiUrl: 'https://agp.ayssa.com.co/',
  urlPath: 'https://agp.ayssa.com.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  company: 1,
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LcjM2wpAAAAAFrG1MIGVV-w4aeDejgVgfYoClHz',

  googleAnalyticsCode: 'UA-140785247-1',
};